import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import React, { forwardRef, useImperativeHandle } from 'react';
import { useForm } from 'react-hook-form';

const ForgotPasswordForm = forwardRef(function (props, ref) {
  const { onSubmit } = props;
  const { register, handleSubmit, formState } = useForm({
    defaultValues: {
      password: '',
    },
  });

  useImperativeHandle(ref, () => ({
    handleSubmitForm: () => {
      handleSubmit((data) =>
        onSubmit({
          password: data.password,
        })
      )();
    },
  }));

  return (
    <form>
      <FormControl error={!!formState.errors.password} margin='normal' variant='outlined' fullWidth>
        <InputLabel htmlFor='outlined-username'>Новый пароль</InputLabel>
        <OutlinedInput
          id='outlined-email'
          label='Новый пароль'
          variant='outlined'
          fullWidth
          placeholder='Введите новый пароль'
          {...register('password', {
            required: true,
            minLength: 6,
          })}
        />
      </FormControl>
    </form>
  );
});

export default ForgotPasswordForm;
